import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Divination by coin",
  "description": "",
  "published": "2008-08-15T00:00:00.000Z",
  "redirect_from": ["/blog/divination-by-coin/swizec/82"],
  "categories": "intrigues, life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Sometimes I deal in divination by coin, that is to say I ask the coin yes or no questions and it does its best to answer. I'm not exactly certain how it works but I think it's a combination of omni-connectedness, will and subconscious. My theory is that the coin doesn't really know anything but is rather an aide in communicating with one's subconscious through small and uncontrollable muscle twitches. The idea is that your subconscious mind knows the answer to just about anything and is pretty unspoilable by what the conscious mind is thinking therefore what you ask of it is usually true.`}</p>
    <p>{`But it's always rather difficult to say what exactly is true because the coin does get it wronga dn `}<em parentName="p">{`can`}</em>{` sometimes be affected by strong enough fears and expectations. So it's important to do cross-examinations and ask it questions in such a way that after a few tries you can be certain the answer you've got is correct.`}</p>
    <p>{`But even then there's still the seed of doubt. However I've gotten proof once and for all that what the coin says is correct. My girlfriend's in Amsterdam and so out of worry I've been doiung coin divination quite a lot lately ... it's the bad kind of worry by the way, the one where I think she'll most certainly cheat on me. And you know what? She bloody did!`}</p>
    <p>{`I asked and asked the coin whether she would or already did cheat on me and after I got quite worrying replies I decided to confront her about it via sms and she replied that she did in fact make out with somebody who wasn't me ... the girl she went to amsterdam with! Bloody thing! And she had the audacity to `}<em parentName="p">{`brag`}</em>{` about it, almost as if I'd be delighted that she recorded a video of her making out with her friend.`}</p>
    <p>{`Well what's worrying now is that the coin says they didn't just make out, but had lesbian sex and that she liked it more than she likes having sex with me. Which I must say bothers me a lot. Oooh there's going to be some heavy chatting with that girl when she comes home next week.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      